import React, { ReactElement } from 'react';
import SinglePageTab from '../../../app/common/single-page-tab/single-page-tab.component';
import SettingsAccountSettingList from '../settings-account-setting-list/settings-account-setting-list.component';
import { SETTING_NAME_ACCOUNT_STATISTIC_SETTINGS } from '../../../../constants/entity/setting-names';

const SettingsAccountStatisticItems: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSaving,
    isSaveDisabled,
    isEditMode,
    isRightDrawerOpen,
    accountSettingsMap,
    statisticItemList,
    formError,
    onCancelForm,
    onSubmitForm,
  } = props;

  const isEmpty: boolean = !accountSettingsMap || !accountSettingsMap[SETTING_NAME_ACCOUNT_STATISTIC_SETTINGS];
  const formPrefix: string = 'accountSettings';

  return (
    <SinglePageTab
      isScrollable
      withNoPadding
      isSaving={isSaving}
      isSaveDisabled={isSaveDisabled}
      isEditMode={isEditMode}
      isRightDrawerOpen={isRightDrawerOpen}
      isEmpty={isEmpty}
      formError={formError}
      onCancelForm={onCancelForm}
      onSubmitForm={onSubmitForm}
    >
      <SettingsAccountSettingList
        isEditMode={isEditMode}
        accountSettingListData={accountSettingsMap && accountSettingsMap[SETTING_NAME_ACCOUNT_STATISTIC_SETTINGS].value}
        formPrefix={`${formPrefix}[${SETTING_NAME_ACCOUNT_STATISTIC_SETTINGS}].value`}
        nameColumnText="Statistic Item Name"
        settingList={statisticItemList}
      />
    </SinglePageTab>
  );
});

export default SettingsAccountStatisticItems;
